import { WarningItemGraphTypes } from './types';

import cn from './styles.module.css';

const WarningItemGraph = ({
  maxCount,
  warningReportsCount,
  selectedWarningsReportCount,
  organizationDetails,
}: WarningItemGraphTypes) => {
  let width = (warningReportsCount / maxCount) * 100;
  let filteredWidth;

  if (width < 1) {
    width = 3;
  }

  if (selectedWarningsReportCount) {
    filteredWidth = (selectedWarningsReportCount / warningReportsCount) * 100;

    if (filteredWidth < 1) {
      filteredWidth = 20;
    }
  }

  return (
    <div
      className={`${cn.warningsReportOverviewContentBottomRightItem} ${
        organizationDetails ? cn.lessWidth : ''
      }`}
    >
      <div
        className={cn.graphItem}
        style={{
          // eslint-disable-next-line no-nested-ternary
          width: warningReportsCount
            ? maxCount === warningReportsCount
              ? '100%'
              : `${width}%`
            : '0',
        }}
      >
        <div
          className={cn.graphItemSelected}
          style={{
            width: selectedWarningsReportCount ? `${filteredWidth}%` : '',
          }}
        />
      </div>
    </div>
  );
};

export default WarningItemGraph;
